import React, { Component } from "react";
import { connect } from "react-redux";
import {
  LIST_PAGE_SIZES,
  CLIENT_CRM_TYPE_FILTER,
  CLIENT_GROUP_CRM_FILTER
} from "Config";
import debounce from "lodash.debounce";
import styles from "./Item.local.scss";

import {
  setOrganizationListFilterTitle,
  setOrganizationListPaginationPage,
  setOrganizationListPageSize,
  setOrganizationListFilterType,
  setOrganizationListFilterJuridicalForm,
  setFilterCollaborators,
  setFilterRoleCollaborators,
  setOrganizationListSortMetrics,
  setOrganizationListFilterConfigState,
  setClientCRMType,
  setClientCRMGroup
} from "actions";
import OrganizationActions from "./OrganizationActions";
import {
  fetchOrganisationsJuridicalFormSuggestions,
  fetchCollaboratorsSuggestions
} from "thunks";
import TTPFilterHorizontalBar from "../Common/filters/TTPFilterHorizontalBar";
import _ from "i18n";
import { COLLABORATOR_ROLE_FILTER } from "../../config";

class OrganizationFilter extends Component {
  constructor(props) {
    super(props);

    this.loadJuridicalFormSuggestions = debounce(
      this.loadJuridicalFormSuggestions,
      1000
    );
    this.props.spaceAs === "MANGER" &&
      (this.loadCollaboratorSuggestions = debounce(
        this.loadCollaboratorSuggestions,
        1000
      ));
    this.state = {
      getSynchro: false
    };
  }

  componentDidMount() {
    this.setState({
      ...this.state,
      getSynchro: false
    });
    if (this.props.collaboratorId) {
      this.loadCollaborator();
    }
  }

  componentDidUpdate(
    prevProps: Readonly<P>,
    prevState: Readonly<S>,
    snapshot: SS
  ) {
    const { synchro } = this.props;
    const { getSynchro } = this.state;
    if (synchro && !getSynchro) {
      this.setState({
        ...this.state,
        getSynchro: true
      });
    }
  }

  handleSearchInputChange(word) {
    this.props.changeSearchedValue(word);
    this.props.dispatch(setOrganizationListFilterTitle(word));
  }

  filterFormIsVisible = isVisible => {
    this.props.filterFormIsVisible(isVisible);
  };

  handleResetFilter = () => {
    this.props.dispatch(setOrganizationListPaginationPage(LIST_PAGE_SIZES[0]));
  };
  handleOrganizationListPageSizeChange = selected => {
    this.props.dispatch(setOrganizationListPageSize(selected));
  };
  handleOrganizationListFilterType = selected => {
    this.props.dispatch(setOrganizationListFilterType(selected));
  };
  handleOrganizationListFilterConfigState = selected => {
    this.props.dispatch(setOrganizationListFilterConfigState(selected));
  };
  handleOrganizationListSortMetrics = selected => {
    this.props.dispatch(setOrganizationListSortMetrics(selected));
  };

  handleJuridicalFormChange = selected => {
    this.props.dispatch(setOrganizationListFilterJuridicalForm(selected));
  };

  handleCollaboratorChange = selected => {
    this.props.dispatch(setFilterCollaborators(selected ? [selected] : []));

    const url = new URL(window.location);
    if (selected && selected.value) {
      url.searchParams.set("collaboratorId", selected.value);
      window.history.replaceState(null, "", url.toString());
    } else {
      url.searchParams.delete("collaboratorId");
      window.history.replaceState(null, "", url.toString());
    }
  };

  handleTypeCRMClientChange = selected => {
    this.props.dispatch(setClientCRMType(selected));
  };

  handleGroupCRMClientChange = selected => {
    this.props.dispatch(setClientCRMGroup(selected));
  };

  handleDefaultGroupeCRMClientChange = () => {
    this.props.dispatch(
      setClientCRMGroup([
        "AiSBL",
        "ASBL",
        "ASBL petite entreprise",
        "Fondation privée",
        "Indépendants",
        "Indépendants petite entreprise",
        "Particuliers",
        "Sociétés",
        "Sociétés petite entreprise"
      ])
    );
  };

  handleCollaboratorRoleChange = selected => {
    this.props.dispatch(setFilterRoleCollaborators(selected));
  };

  loadJuridicalFormSuggestions = (searchWord, callback) => {
    let { lng } = this.props;
    lng = lng.charAt(0).toUpperCase() + lng.slice(1);
    this.props
      .dispatch(fetchOrganisationsJuridicalFormSuggestions({ searchWord, lng }))
      .then(res => {
        const categories = res.value.data.data.map(t => {
          return { value: t.id, label: t["label" + lng], color: "#000000" };
        });
        callback(categories);
      })
      .catch(er => {
        callback([]);
      });
  };

  loadCollaboratorSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchCollaboratorsSuggestions(searchWord))
      .then(res => {
        const categories = res.value.data.data.map(t => {
          return { value: t.id, label: t.name, color: "#000000" };
        });
        callback(categories);
      })
      .catch(er => {
        callback([]);
      });
  };

  loadCollaborator = searchWord => {
    let collabSelected;
    this.props.dispatch(fetchCollaboratorsSuggestions(searchWord)).then(res => {
      // eslint-disable-next-line array-callback-return
      res.value.data.data.map(t => {
        if (t.id == this.props.collaboratorId) {
          collabSelected = {
            value: t.id,
            label: t.name,
            color: "#000000"
          };
          this.handleCollaboratorChange(collabSelected);
        }
      });
    });
  };

  render() {
    let { organizationsFilter, pageSize, synchro } = this.props;
    let filters = [];

    let asyncFilters = [
      {
        placeholder: _("juridicalForm"),
        handleChange: this.handleJuridicalFormChange,
        loadSuggestions: this.loadJuridicalFormSuggestions,
        value: organizationsFilter.juridicalForms
      }
    ];

    if (synchro)
      filters.push(
        {
          placeholder: _("Type Client (CRM)"),
          options: CLIENT_CRM_TYPE_FILTER,
          values: organizationsFilter.clientCRMTypes,
          action: this.handleTypeCRMClientChange
        },
        {
          placeholder: _("Groupe Client (CRM)"),
          options: CLIENT_GROUP_CRM_FILTER,
          isRefresh: true,
          values: organizationsFilter.clientCRMGroup,
          action: this.handleGroupCRMClientChange
        }
      );
    this.props.spaceAs !== "COLLABORATOR" &&
      synchro &&
      asyncFilters.push({
        placeholder: _("collaborator"),
        handleChange: this.handleCollaboratorChange,
        loadSuggestions: this.loadCollaboratorSuggestions,
        value: organizationsFilter.collaborators,
        isSimple: true
      });

    (organizationsFilter.collaborators.length > 0 ||
      this.props.spaceAs === "COLLABORATOR") &&
      synchro &&
      filters.push({
        isSimple: true,
        placeholder: _("role"),
        options: COLLABORATOR_ROLE_FILTER,
        values: organizationsFilter.roleCollaborator,
        action: this.handleCollaboratorRoleChange
      });

    return (
      <div className="row align-center medium-11">
        <div className={`medium-12 ${styles.filter_bar}`}>
          <OrganizationActions
            presentationStatusChange={this.props.presentationStatusChange}
            presentationState={this.props.presentationState}
            synchronizationStatusChange={this.props.synchronizationStatusChange}
            synchroState={this.props.synchroState}
            cardsFetching={this.props.cardsFetching}
          />
          <TTPFilterHorizontalBar
            filters={filters}
            asyncFilters={asyncFilters}
            searchInputValue={organizationsFilter.name}
            searchPlaceholder={_("searchByNameOrVATnumber")}
            pageSize={pageSize}
            handleResetFilter={this.handleResetFilter}
            handleListPageSizeChange={this.handleOrganizationListPageSizeChange}
            handleSearchInputChange={this.handleSearchInputChange.bind(this)}
            filterFormIsVisible={this.filterFormIsVisible}
            sort={organizationsFilter.sortMetrics}
            handleListSortChange={this.handleOrganizationListSortMetrics}
            cssClass="medium-12"
            isOpen={
              this.props.collaboratorId ||
              organizationsFilter.collaborators.length
            }
            handleDefaultGroupeCRMClientChange={
              this.handleDefaultGroupeCRMClientChange
            }
          />
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  organizationsFilter: state.organizations.list.filter,
  spaceAs: state.auth.spaceAs,
  pageSize: state.organizations.list.pageSize,
  lng: state.params.lng,
  synchro: state.fiduciary.data && state.fiduciary.data.synchro
});

export default connect(mapStateToProps)(OrganizationFilter);



// WEBPACK FOOTER //
// ./src/components/OrganizationList/OrganizationFilter.js